import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll to top of page on every route change (except when the path contains a hash).
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
};

export default ScrollToTop;
